import { useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errMsg } from "../../lib/api";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { ImageUpload } from "./ImageUpload";

const Field = ({ label, children }) => (
  <label className="block"><span className="text-sm font-bold text-slate-700">{label}</span><div className="mt-2">{children}</div></label>
);

export const SettingsManager = () => {
  const [s, setS] = useState(null);
  const [pw, setPw] = useState({ old_password: "", new_password: "" });

  useEffect(() => {
    adminApi.get("/admin/settings").then((r) => setS(r.data));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await adminApi.put("/admin/settings", s);
      toast.success("Ayarlar kaydedildi");
    } catch (er) {
      toast.error(errMsg(er));
    }
  };

  const changePw = async (e) => {
    e.preventDefault();
    try {
      await adminApi.post("/admin/change-password", pw);
      toast.success("Şifre değiştirildi");
      setPw({ old_password: "", new_password: "" });
    } catch (er) {
      toast.error(errMsg(er, "Şifre en az 6 karakter olmalı"));
    }
  };

  if (!s) return <p className="text-slate-500">Yükleniyor...</p>;

  return (
    <div className="grid lg:grid-cols-2 gap-6">
      <form onSubmit={save} className="bg-white rounded-3xl border border-black/5 p-6 space-y-5" data-testid="settings-form">
        <h2 className="font-display text-xl font-bold text-slate-800">Ana sayfa ve iletişim</h2>
        <Field label="Ana sayfa resim yazısı (haber yoksa görünür)">
          <Input value={s.hero_caption} maxLength={160} onChange={(e) => setS({ ...s, hero_caption: e.target.value })} className="h-12 rounded-xl" data-testid="settings-caption-input" />
        </Field>
        <div>
          <p className="text-sm font-bold text-slate-700 mb-2">Varsayılan ana sayfa resmi</p>
          <ImageUpload value={s.hero_image} onChange={(p) => setS({ ...s, hero_image: p })} testid="settings-hero" />
        </div>
        <Field label="İletişim telefonu">
          <Input value={s.contact_phone} onChange={(e) => setS({ ...s, contact_phone: e.target.value })} className="h-12 rounded-xl" data-testid="settings-phone-input" />
        </Field>
        <Field label="İletişim e-postası">
          <Input value={s.contact_email} onChange={(e) => setS({ ...s, contact_email: e.target.value })} className="h-12 rounded-xl" data-testid="settings-email-input" />
        </Field>
        <Button type="submit" className="h-12 px-8 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold" data-testid="settings-save-btn">Kaydet</Button>
      </form>
      <form onSubmit={changePw} className="bg-white rounded-3xl border border-black/5 p-6 space-y-5 h-fit" data-testid="admin-password-form">
        <h2 className="font-display text-xl font-bold text-slate-800">Şifremi değiştir</h2>
        <Field label="Mevcut şifre">
          <Input required type="password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} className="h-12 rounded-xl" data-testid="admin-old-password-input" />
        </Field>
        <Field label="Yeni şifre (en az 6 karakter)">
          <Input required minLength={6} type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="h-12 rounded-xl" data-testid="admin-new-password-input" />
        </Field>
        <Button type="submit" className="h-12 px-8 rounded-full bg-[#E07A5F] hover:bg-[#c9664c] font-bold" data-testid="admin-change-password-btn">Şifreyi Değiştir</Button>
      </form>
    </div>
  );
};
